import * as PIXI from "pixi.js";
import {KarenLayers, Layers} from "./KarenLayers";
import {KarenTextStyles} from "../KarenTextStyles";
import {Karen} from "../Karen";
import {KarenSymbolName} from "../symbol/KarenSymbolConfig";
import {IStickyFS} from "../server/data/IKarenData";
import {TimelineLite} from "gsap";

export class KarenMultiplierWaysTextView {
    public increaseFSxWaysSize: boolean = false;
    private _container: PIXI.Container;
    private _noOfWays: PIXI.Text;
    private _noOfSymbolWin: PIXI.Text;
    private _waysText: PIXI.Text;

    constructor() {
        this.init();
    }

    public setXWays(value: string): void {
        let extraNum: number = 1;
        if (value.length > 6) {
            extraNum = 1.5
        }
        this._noOfWays.style.fontSize = 32 - ((value.length - 2) * extraNum);
        this._noOfWays.text = value;
    }

    public setFSXWays(): void {
        let value: string = this.calculateXWaysForFS().toString();
        this.setXWays(value);
    }

    public calculateXWAYSOnScatterLanding(reelId: number): void {
        let reelSize: number[] = JSON.parse(JSON.stringify(Karen.model.data.evaluatedArea ? this.calculateReelSize(Karen.model.data.evaluatedArea) : Karen.model.data.gameAreaSize));
        let reelData: string[] = Karen.model.data.reels[reelId];
        let stickyXWaysFSPositions: IStickyFS = Karen.model.data.stickyXWaysFSPositions;
        let scatterLanded: boolean = false;
        let totalXWAYS: number = 1;
        for (let idx: number = 1; idx < reelData.length && idx <= reelSize[reelId]; idx++) {
            if (reelData[idx] === KarenSymbolName.S && stickyXWaysFSPositions[reelId]) {
                scatterLanded = true;
                break;
            }
        }
        if (scatterLanded) {
            let fsXWaysSizeBefore: number = (Karen.model.data.fsXWaysSizeBefore ? Karen.model.data.fsXWaysSizeBefore : Karen.model.data.fsXWaysSize) + (this.increaseFSxWaysSize ? 1 : 0);
            Object.keys(stickyXWaysFSPositions).forEach((key) => {
                let val: number = parseInt(key);
                reelSize[val] = reelSize[val] + (fsXWaysSizeBefore - 1);
            });
            reelSize.forEach((size: number) => {
                totalXWAYS = totalXWAYS * size;
            });
            this.setXWays(totalXWAYS.toString());
        }
    }

    public update(text: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._noOfSymbolWin.visible = true;
            this._noOfSymbolWin.text = text + " ways ";
        });
        return tl;
    }

    private init(): void {
        this._noOfWays = new PIXI.Text("486", {...KarenTextStyles.MULTIPLIER_TEXT_STYLE});
        this._waysText = new PIXI.Text("Ways", KarenTextStyles.MULTIPLIER_TEXT_STYLE);
        this._noOfWays.style.fontSize = 31;
        this._noOfWays.position.set(189, 530);
        this._noOfWays.anchor.set(0.5, 0.5);
        this._waysText.position.set(190, 560);
        this._waysText.anchor.set(0.5, 0.5);
        KarenLayers.getLayer(Layers.FOREGROUND)?.addChild(this._noOfWays, this._waysText);
        this._noOfSymbolWin = new PIXI.Text("1", {...KarenTextStyles.WAYS_TEXT_COUNTUP_STYLE});
        this._noOfSymbolWin.position.set(360, 400);
        this._noOfSymbolWin.anchor.set(0.5, 0.5);
        this._noOfSymbolWin.visible = false;
        this._noOfSymbolWin.style.fontSize = 35;
        KarenLayers.getLayer(Layers.SYMBOL_WIN_MULTIPLIER)?.addChild(this._noOfSymbolWin);
    }

    private calculateXWaysForFS(): number {
        let reelSize: number[] = JSON.parse(JSON.stringify(Karen.model.data.evaluatedArea ? this.calculateReelSize(Karen.model.data.evaluatedArea) : Karen.model.data.gameAreaSize));
        let totalXWAYS: number = 1;
        let stickyXWaysFSPositions: {} = Karen.model.data.stickyXWaysFSPositions;
        let fsXWaysSizeBefore: number = (Karen.model.data.fsXWaysSizeBefore ? Karen.model.data.fsXWaysSizeBefore : Karen.model.data.fsXWaysSize) + (this.increaseFSxWaysSize ? 1 : 0);
        Object.keys(stickyXWaysFSPositions).forEach((key) => {
            let val: number = parseInt(key);
            reelSize[val] = reelSize[val] + (fsXWaysSizeBefore - 1);
        });
        reelSize.forEach((size: number) => {
            totalXWAYS = totalXWAYS * size;
        });
        return totalXWAYS;
    }

    private calculateReelSize(evaluatedArea: string[][]): number[] {
        let reelSize: number[] = [];
        evaluatedArea.forEach((reel) => {
            reelSize.push(reel.length);
        });
        return reelSize;
    }
    public hideNoOfWays():void{
        this._noOfSymbolWin.visible =false;
    }

}
